import React, { useState } from "react";
import { FormGroup, Button } from "reactstrap";
import UCSApi from "../../api/UCSApi";
import { useSideChannelSubscription } from "../../util/useSideChannel";
import Loader from "../Loader";
import Notification from "../Notification";

function CallUCSAPIButton(props) {
  const {
    formContext,
    schema: { title },
    uiSchema: { "ui:readonly": readonly },
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [newError, setError] = useState("");
  const { sideChannel } = formContext;
  const formObject = useSideChannelSubscription(sideChannel, 1) || [{}];
  const curClientIdx = formContext?.formDefinition?.curClientIdx || 0;

  async function fetchData(e) {
    e.preventDefault();

    setIsLoading(true);
    let response;

    try {
      const caseId = formObject.id;
      const clientIndex = curClientIdx;

      const requestData = {
        caseId,
        clientIndex
      };

      setError("");
      response = await UCSApi.callUCSAPI(requestData);
    } catch (error) {
      setIsLoading(false);
      if (error.message === "Not Found") {
        setError("No se encontró el caso con este ID.");
      } else {
        console.error("Error calling UCS API:", error);
        setError(error.message);
      }
    }

    // If UCS returns a successful response, set the customer number into the form
    if (
      response &&
      !response.errorCode &&
      !response.errorMessage && response.status !== 'Error'
    ) {
      formContext.setFormDataValues({
        "infCliUCS.numCliUCS": response.identityColumn.toString(),
      });
    } else if (
      response &&
      response.errorMessage || response.status === 'Error'
    ) {
      setError(
        response.errorMessage ? response.errorMessage : "No se pudo crear el cliente en UCS.",
      );
    }

    setIsLoading(false);
  }

  return (
    <>
      {newError ? (
        <Notification color="danger">
          <div>{newError}</div>
        </Notification>
      ) : null}
      {!readonly ? (
        <FormGroup className="file-field" disabled={readonly || isLoading}>
          <Button
            className="btn btn-secondary"
            target="_blank"
            onClick={(e) => fetchData(e)}
          >
            {isLoading ? <Loader /> : title}
          </Button>
        </FormGroup>
      ) : (
        <></>
      )}
    </>
  );
}

export default CallUCSAPIButton;
